import { render, staticRenderFns } from "./data-service.vue?vue&type=template&id=0e1cb510&scoped=true"
import script from "./data-service.vue?vue&type=script&lang=js"
export * from "./data-service.vue?vue&type=script&lang=js"
import style0 from "./data-service.vue?vue&type=style&index=0&id=0e1cb510&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1cb510",
  null
  
)

export default component.exports